/**
 * Convert a 12h time string plus AM/PM marker into a normalized 24h "HH:mm".
 *
 * Defensive by design: returns null for missing or invalid inputs (falsy
 * time12h/amPm, missing ":" separator, missing minutes, NaN hour, or an amPm
 * outside "AM"/"PM") so callers such as validators can short_circuit instead
 * of producing a misleading error. Callers in the submit flow can safely
 * assume a valid string because the form validates the inputs beforehand.
 *
 * @param {string} time12h Time in 12h format, e.g. "1:30" or "12:00".
 * @param {'AM'|'PM'} amPm AM or PM marker.
 * @returns {string|null} 24h time in "HH:mm" format, or null if invalid.
 */
const convert12hTo24h = (time12h, amPm) => {
  if (!time12h || !amPm) return null;
  const parts = String(time12h).split(':');
  const hourStr = parts[0];
  const minutes = parts[1];
  if (!hourStr || !minutes) return null;
  let hour = parseInt(hourStr, 10);
  if (Number.isNaN(hour)) return null;
  if (amPm !== 'AM' && amPm !== 'PM') return null;

  if (amPm === 'AM') {
    if (hour === 12) hour = 0;
  } else if (hour !== 12) {
    hour += 12;
  }

  return `${hour.toString().padStart(2, '0')}:${minutes}`;
};

export { convert12hTo24h };
